// extracted by mini-css-extract-plugin
module.exports = {"block":"Jm5pN","itemImage":"VqHhA","itemSlide":"c9YH5"};